// bao migrate skip

import TabPage from "./../../factories/tab-page";
import BaoDialog from "./../../factories/bao-dialog";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import GenerictListTab from "./../../factories/generic-list-tab";
import * as moment from "moment";
class RiskManagementTab extends GenerictListTab {
    Confidentiality = ko.observable(false);
    Availability = ko.observable(false);
    Integrity = ko.observable(false);
    Models = ko.observableArray([]);
    MainModel = ko.observableArray([]);
    ConfigurationItemId = ko.observable("");
    Year = ko.observable();
    YearCollection = ko.observableArray([]);
    DialogWidth = 550;
    ControllerUrl = "RiskManagementTab";
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    CustomFilter() {
        return null;
    }
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.ConfigurationItemId = parent.ConfigurationItemId;
        this.GetConfigurationItem350();
    }
    Dialog(id: string): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: id
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                var item = dialog.ViewModel();
                delete item.Parent;
                this.ItemCompleteCheck(item).then((validateResult) => {
                    if (validateResult) {
                        this.Save(ko.map.toJS(item)).then(() => {
                            this.TabPage.DirtyFlag(true);
                            dialog.Close();
                        });
                    }
                });
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            var vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            dialog.ViewModel(vm);
            dialog.ViewModel().YearCollection = ko.observableArray([]);
            dialog.ViewModel().Year = ko.observable("");
            Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), (result) => {
                var YearArray = [];
                YearArray = result.filter(years => years.key != "");
                YearArray = YearArray.map(year => year.Key);
                dialog.ViewModel().YearCollection(YearArray);
                if (this.Selection() != null && this.Selection().length == 1) {
                    dialog.ViewModel().Year(this.Selection()[0].Year);
                }
                else {
                    dialog.ViewModel().Year(moment().year());
                }
                dialog.Open(null);
                this.TabPage.IsLoading(false);
            });
        });
    }
    CalculateRisk(item: any) {
        item.CalculatedRisk = item.QuantifiableDamagePotential + item.NotQuantifiableDamagePotential;
    }
    CalculateAverage(item: any) {
        item.CalculatedAverage = (Math.max(item.QuantifiableDamagePotential, item.NotQuantifiableDamagePotential) * 3 + Math.min(item.QuantifiableDamagePotential, item.NotQuantifiableDamagePotential) + item.Probability / 2).toFixed(1);
    }
    Commit(saveTime: string): JQueryPromise<void> {
        return super.Commit(saveTime).then(() => {
            Bao.post("RiskManagementTab/SaveConfigurationItem350", JSON.stringify({
                configurationItemId: this.ConfigurationItemId(),
                confidentiality: this.Confidentiality(),
                availability: this.Availability(),
                integrity: this.Integrity()
            }));
        });
    }
    GetConfigurationItem350() {
        Bao.post("RiskManagementTab/GetConfigurationItem350", JSON.stringify({
            configurationItemId: this.ConfigurationItemId()
        }), ((result) => {
            this.Confidentiality(result.Confidentiality);
            this.Availability(result.Availability);
            this.Integrity(result.Integrity);
        }));
    }
    Remove(itemIds: string[]): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post(this.UrlRemove(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            ids: itemIds
        }), () => {
            this.Get().then(() => {
                this.TabPage.DirtyFlag(true);
                def.resolve();
            });
        });
        return def.promise();
    }
    init() {
        return $.when(super.init());
    }
}
export default RiskManagementTab;